import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'risingFallingArrow',
  standalone: false
})
export class RisingFallingArrowPipe implements PipeTransform {
  transform(value: number): string {
    let rotate;

    switch (value) {
      case -1:
        rotate = 'rotate-45';
        break;
      case 1:
        rotate = 'rotate-315';
        break;
      case 0:
      default:
        rotate = '';
        break;
    }

    return `<span class="fa fa-long-arrow-alt-right ${rotate} fa-lg"></span>`;
  }
}
